<template>
    <div class="content">
        <div class="b_img"></div>
        <ul v-for="(item,index) in dataJson" >
            <li >
                <div :id="item.id" ></div>
                <h3 class="title">{{item.name}}</h3>
                <template v-if="item.dataType=='table'" v-for="itemdatas in item.datas">
                    <h4 class="subName" v-if="itemdatas.titleName">{{itemdatas.titleName}}</h4>
                    <el-table :data="itemdatas.td">
                        <template v-for="tabledata in itemdatas.tabledata">
                            <el-table-column :prop="tabledata.tdName" :label="tabledata.tableHead" :min-width="tabledata.tableHead=='说明'?250:' '" align="center">
                            </el-table-column>
                        </template>
                    </el-table>
                </template>
                <div v-if="item.dataType=='text'">{{item.datas}}</div>
                <div v-if="item.dataType=='code'">
                    <slot :name="item.datas">
                        只有在没有要分发的内容时才会显示。
                    </slot>
                </div>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            dataJson: [
                { id: "appendixData_0",name: "支付方式", datas: this.Pdatas.payMethod, dataType: "table" },
                { id: "appendixData_1",name: "支付来源", datas: this.Pdatas.payOrigin, dataType: 'table' },
                { id: "appendixData_2",name: "进场说明", datas: this.Pdatas.inOut_in, dataType: 'table' },
                { id: "appendixData_3",name: "出场说明", datas: this.Pdatas.inOut_out, dataType: 'table' },
                { id: "appendixData_4",name: "VIP类型", datas: this.Pdatas.vipType, dataType: 'table' },
                { id: "appendixData_5",name: "进出场类型", datas: this.Pdatas.enterLeaveType, dataType: 'table' },
                { id: "appendixData_6",name: "订单类型", datas: this.Pdatas.userBillType, dataType: 'table' },
                { id: "appendixData_7",name: "车牌颜色", datas: this.Pdatas.plateColor, dataType: 'table' },
                { id: "appendixData_8",name: "月票是否可开通状态码", datas: this.Pdatas.allowBuyMonthlyTicketCode, dataType: 'table' }
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    h3 {
        font-size: 16px;
        margin: 20px 0 10px 0;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/appendixStructure.vue